module.exports = __webpack_public_path__ + "img/symbol_6.a467d016.png";